/**
 * El logo del club, en sus tres encajes.
 *
 * Los vectores salen del original del cliente (`Logo y etiquetas viva vector CMYK`)
 * y viven en `public/img/`: se sirven como archivo, no inline, para que no engorden
 * el bundle y el navegador los cachee una sola vez para toda la SPA.
 *
 * - `lockup`  — marca completa en una línea (login, topbar, kiosko).
 * - `stacked` — marca apilada, para cuando hay alto y poco ancho.
 * - `icon`    — sólo la ola y el círculo: espacios chicos y favicon.
 *
 * El logo YA dice «Viva Training Club»: al lado no va el nombre repetido en texto.
 * Por eso el `alt` lo nombra — es lo que lee un lector de pantalla — y donde el logo
 * es el contenido de un link, ese `alt` es el texto accesible del link.
 *
 * Los colores son los del original (violeta #784983, teal #5CB1A1, ámbar #F7A029) y
 * no se re-tiñen con los tokens: una marca no se repinta para que combine.
 */
import { cn } from "../../lib/cn.js";

export type VivaLogoVariant = "lockup" | "stacked" | "icon";

const SOURCES: Record<VivaLogoVariant, string> = {
  lockup: "/img/viva-lockup.svg",
  stacked: "/img/viva-stacked.svg",
  icon: "/img/viva-icon.svg",
};

export interface VivaLogoProps {
  variant?: VivaLogoVariant;
  className?: string;
  /** Decorativo: cuando al lado ya hay un texto que nombra la marca. */
  decorative?: boolean;
}

export function VivaLogo({ variant = "lockup", className, decorative = false }: VivaLogoProps) {
  return (
    <img
      src={SOURCES[variant]}
      alt={decorative ? "" : "Viva Training Club"}
      aria-hidden={decorative || undefined}
      draggable={false}
      className={cn("select-none", className)}
    />
  );
}
